import React, { useState } from "react";
import BackButton from "./BackButton";
import Swal from "sweetalert2";
import { BASE_URL } from "../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./FeedbackModal.css";
import { useAuth } from "../contexts/AuthContext";

import feedbackService from "../services/feedbackService";

const FeedbackModal = ({ isOpen, onClose, onBack }) => {
  const { encryptedData } = useAuth(); // Use encrypted data from AuthContext
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const MIN_CHARS = 5;
  const MAX_CHARS = 2500;

  const handleFeedbackChange = (e) => {
    const value = e.target.value;
    if (value.length <= MAX_CHARS) {
      setFeedback(value);
    }
  };

  const handleSubmit = () => {
    if (feedback.trim() === '') {
      Swal.fire({
        title: 'Error!',
        text: 'Feedback cannot be empty.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }

    if (feedback.trim().length < MIN_CHARS) {
      Swal.fire({
        title: 'Error!',
        text: `Feedback must be at least ${MIN_CHARS} characters long.`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }

    // Confirmation before submission
    Swal.fire({
      title: 'Confirm Submission',
      text: 'Are you sure you want to submit your feedback?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, submit it!',
      cancelButtonText: 'No, cancel!',
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);

        const payload = {
          // member_id: localStorage.getItem("member/member_id"),
          // uid: localStorage.getItem("member/uid"),
          // updated_at: localStorage.getItem("member/updated_at"),
          // optcode: localStorage.getItem("member/optcode"),
          data: encryptedData,
          feedback: feedback,
        };

        const formData = new FormData();
        Object.keys(payload).forEach(key => {
          formData.append(key, payload[key]);
        });

        fetch(`${BASE_URL}/submit-feedback-from-fb`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            setLoading(false);
            if (data.status === 'success') {
              
             feedbackService.recordFeedbackSubmission(encryptedData); // Record submission

              Swal.fire({
                title: 'Success!',
                text: 'Your feedback has been submitted successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
              }).then(() => {
                setFeedback('');
                onClose();
              });
            } else {
              Swal.fire({
                title: 'Oops!',
                text: data.message || 'There was a problem submitting your feedback.',
                icon: 'error',
                confirmButtonText: 'OK',
              });
            }
          })
          .catch(error => {
            setLoading(false);
            console.error('Error:', error);
            Swal.fire({
              title: 'Oops!',
              text: 'Something went wrong. Please try again later.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          });
      }
    });
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-container">
          <div className="modal-header">
            <div className="modal-backrow"><BackButton onClick={onBack || onClose} /></div>
            <h2 className="modal-title">Feedback</h2>
            <button onClick={onClose} className="modal-close-btn">
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="modal-body">
            <p className="feedback-description">
              We're sorry to hear that you were not satisfied with our service. Your feedback is important to us, and we appreciate your help in making our system better.
            </p>
            <textarea
              value={feedback}
              onChange={handleFeedbackChange}
              placeholder="Please provide your feedback here..."
              className="feedback-textarea"
            />
            <div className="character-count">
              {feedback.length}/{MAX_CHARS} characters
            </div>
            {/* <p className="sensitive-info-text">
              Please don't include any sensitive information 
              <span 
                style={{cursor: 'pointer', color: '#666', marginLeft: '4px'}} 
                title="Sensitive information is any data that should be protected. For example, don’t include passwords, credit card numbers, and personal details."
              >
                ❓
              </span>
            </p> */}
          </div>
          <div className="modal-footer">
            <button onClick={onClose} className="cancel-button">Cancel</button>
            <button 
              onClick={handleSubmit} 
              className="submit-button" 
              disabled={loading}
            >
              {loading ? (
                <>
                  Submitting...
                  <div className="spinner"></div>
                </>
              ) : (
                'Submit'
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeedbackModal;